<template>
    <MainLayout>
        <SearchHeader @search-change="searchProducts" /> 
    </MainLayout>

    <!-- Выбор категории товара (слайдер) -->
    <ProductCategorySlider 
        :product-categories="categories"
        @category-selected="filterByCategory"
    />

    <MainLayout style="margin-bottom: 2vw;">
        <CatalogCardContainer>
            <!-- Состояние загрузки каталога: без него при ошибке сети пользователь видел пустой экран -->
            <div v-if="productsLoading && !products.length" class="catalog-status">
                <span>Загружаем товары...</span>
            </div>
            <div v-else-if="productsError && !products.length" class="catalog-status">
                <span class="catalog-error">{{ productsError }}</span>
                <button class="retry-button" @click="fetchAll">Повторить</button>
            </div>

            <CatalogProductCard
                v-for="product in filteredProducts" 
                :key="product.id" 
                :product-id="product.id"
                :product-name="product.product_name" 
                :photo-url="product.photo_url"
                :labels="product.labels"
            />
        </CatalogCardContainer>

        <!-- Меню с личным кабинетом для дропов -->\
        <DropMenu style="position: fixed; bottom: 20px; right: 0px;"/>
    </MainLayout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainLayout from "@/components/MainLayout.vue";
import SearchHeader from "@/components/SearchHeader.vue";
import ProductCategorySlider from '@/components/ProductCategorySlider.vue';
import CatalogCardContainer from '@/components/CatalogCardContainer.vue';
import CatalogProductCard from '@/components/CatalogProductCard.vue';
import DropMenu from "@/components/DropMenu.vue";
import api from "@/api/api";

export default {
    components: {
        MainLayout, 
        SearchHeader,
        ProductCategorySlider,
        CatalogCardContainer,
        CatalogProductCard,
        DropMenu
    },

    data() {
        return {
            selectedCategoryId: null, // выбранная категория
            userData: null // данные пользователя из URL
        };
    },

    computed: {
        ...mapState(["products", "categories", "productsLoading", "productsError"]),

        // Фильтр по выбранной категории
        filteredProducts() {
            if (!this.selectedCategoryId) return this.products;
            return this.products.filter(
                product => product.category && product.category.id === this.selectedCategoryId
            );
        }
    },

    methods: {
        ...mapActions(["fetchAll", "searchProducts"]),

        filterByCategory(categoryId) {
            this.selectedCategoryId = categoryId;
        },

        // Получение всех данных пользователя из URL параметра data
        parseUserDataFromUrl() {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const dataParam = urlParams.get('data');

                if (dataParam) {
                    const decodedData = decodeURIComponent(dataParam);
                    this.userData = JSON.parse(decodedData);
                    console.log('Данные пользователя из URL:', this.userData);
                    return true;
                } else {
                    console.warn("Параметр data не найден в URL");
                    return false;
                }
            } catch (error) {
                console.error("Ошибка парсинга данных из URL:", error);
                return false;
            }
        },

        // Проверка пользователя по tg_id
        async checkUser() {
            try {
                if (this.userData && this.userData.tg_id) {
                    console.log('Telegram ID:', this.userData.tg_id);
                    const { data } = await api.get(`/users/check_user/${this.userData.tg_id}`);
                    localStorage.setItem('is_drop', data.exists);
                    console.log('Сохранили в localStorage is_drop:', data.exists);
                } else {
                    console.warn("tg_id не найден в данных пользователя");
                }
            } catch (error) {
                console.error("Ошибка в checkUser:", error);
            }
        },

        // Сохранение photo_url в localStorage
        savePhotoUrl() {      
            try {
                if (this.userData && this.userData.photo_url) {
                    localStorage.setItem('photo_url', this.userData.photo_url);
                    console.log('Сохранили photo_url в localStorage:', this.userData.photo_url);
                } else {
                    console.warn("photo_url не найден в данных пользователя");
                }
            } catch (error) {
                console.error("Ошибка в savePhotoUrl:", error);
            }
        },

        // Сохранение всех данных пользователя
        saveUserData() {
            if (this.userData) {
                // Сохраняем все данные пользователя в localStorage
                localStorage.setItem('user_data', JSON.stringify(this.userData));
                
                // Сохраняем отдельно tg_id для удобства
                if (this.userData.tg_id) {
                    localStorage.setItem('tg_id', this.userData.tg_id);
                }
                
                // Сохраняем photo_url если есть
                if (this.userData.photo_url) {
                    localStorage.setItem('photo_url', this.userData.photo_url);
                }
                
                // Сохраняем имя пользователя если есть
                if (this.userData.first_name) {
                    localStorage.setItem('first_name', this.userData.first_name);
                }
                
                console.log('Все данные пользователя сохранены в localStorage');
            }
        }
    },

    async mounted() {
        // 1. Сначала парсим данные из URL
        this.parseUserDataFromUrl();
        
        // 2. Затем сохраняем данные пользователя
        this.saveUserData();
        
        // 3. Проверяем пользователя в базе и загружаем продукты параллельно,
        // чтобы зависший check_user не блокировал каталог
        await Promise.all([
            this.checkUser(),
            this.fetchAll()
        ]);
    },
}
</script>

<style scoped>
.catalog-status {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3vw;
    padding: 8vw 4vw;
    font-family: 'Inter', sans-serif;
    font-size: 4vw;
    text-align: center;
    color: #888;
}

.catalog-error {
    color: #d33;
}

.retry-button {
    padding: 2.5vw 6vw;
    border: none;
    border-radius: 25px;
    background-color: #fff;
    color: #000;
    font-family: 'Inter', sans-serif;
    font-size: 4vw;
}
</style>
